import styled from "styled-components";
import Mask from "react-input-mask";

export const Container = styled.div`
  @media (max-width: 1024px) {
    height: 100vh;
    overflow: auto;
  }
`;

export const Form = styled.form`
  position: relative;
  margin: 20px auto 0;
  width: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: #f1f1f1;
  @media (max-width: 1024px) {
    margin-top: 80px;
  }
`;

export const ButtonBack = styled.button`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
`;

export const LabelBack = styled.p`
  margin-left: 10px;
  color: #707070;
`;

export const IconBack = styled.img`
  width: 20px;
  height: 20px;
`;

export const UploadImage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
`;

export const DivImage = styled.label`
  cursor: ${props => !props.editable ? "inherit" : "pointer"};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
`;

export const DivIcon = styled.div`
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  background: #2196f3;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

export const InputNone = styled.input`
  display: none;
`;

export const ImageDependent = styled.img`
  width: 96px;
  height: 96px;
  border-radius: 48px;
`;

export const Titles = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 0 20px;
`;

export const Title = styled.h2`
  margin-bottom: 5px;
  font-size: 18px;
`;

export const SubTitle = styled.p`
  color: #707070;
`;

export const DivLogo = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const Inputs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 680px;

  @media (max-width: 1024px) {
    width: 100%;
    overflow: auto;
  }
`;

export const DivInput = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 325px;
  height: 60px;

  label {
    width: 100%;
    text-align: left;
    font-size: 10px;
    height: 12px;
  }

  @media (max-width: 1024px) {
    width: 350px;
  }

  @media (max-width: 425px) {
    width: 270px;
  }
`;

export const Select = styled.select`
  border: 0;
  border-bottom: 1px solid #000;
  background-color: transparent;
  width: 100%;
  padding: 7px 0;
`;

export const ErrorMessage = styled.p`
  color: red;
  width: 100%;
  padding: 5px 0;
  font-size: 10px;
`;

export const ErrorImage = styled.p`
  position: absolute;
  left: 5px;
  bottom: -25px;
  color: red;
  width: 100%;
  padding: 5px 0;
  font-size: 10px;
`;

export const Button = styled.button`
  width: 150px;
  height: 45px;
  background-color: #2196f3;
  color: white;
  border-radius: 25px;
  font-weight: bolder;
  cursor: pointer;
  margin-top: 10px;
  margin-right: ${props => props.marginRight || 0}px;
  padding: 0px 10px;

  @media (max-width: 1024px) {
    width: 80%;
    margin: 16px auto 0px;
    max-width: 200px;
  }
`;

export const Terms = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;

  p {
    margin-left: 5px;
    font-size: 14px;
    color: #707070;
  }

  input[type="checkbox"] {
    border: 1px solid black;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  flex-direction: row; 
  display: flex; 
  justify-content: flex-end;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`